import { Avatar, MyAvatar } from 'components/avatar/Avatar'
import { SBoundAvatarsContainer, SContentContainer } from './ContactNotificationModal.styled'
import { useActualContact } from 'components/contact/contactUtils'
import { Icon } from 'components/icon'
import { Text, Title } from 'components/Typography'
import { colors } from 'utils/colors'
import { ApiType } from 'utils/types'

export const ContactPromoteDemoteModal = (props: {
  contact?: ApiType['TrustedContactResponse']
  isPromoted?: boolean
}) => {
  const { actualContact } = useActualContact(props.contact)

  const name = actualContact?.first_name || actualContact?.email

  return (
    <SContentContainer>
      <Text variant="bodyBold">
        {props.isPromoted
          ? 'You have been promoted to a Legacy Contact!'
          : 'You are no longer a Legacy Contact'}
      </Text>
      <SBoundAvatarsContainer>
        <MyAvatar size={120} />
        <Avatar owner={actualContact} size={120} />
        <Icon name={props.isPromoted ? 'ShieldCheck' : 'Check'} color={colors.blue[500]} />
      </SBoundAvatarsContainer>
      <Title variant="h7">
        {props.isPromoted
          ? `Congratulations! You've now been elevated to ${name}'s Legacy Contact.`
          : `You were demoted to ${name}'s Trusted Contact `}
      </Title>
      <Text>
        {props.isPromoted
          ? 'This is a critical role and means you will be asked to help steward what happens to all accounts and content when this person passes away. '
          : 'We felt it was important to let you know that this person has found a new Legacy Contact. Since there can only be one, they have chosen you as a Trusted Contact instead, which means you still play a vital role in the management of their life and legacy. They can share access now, never, or after they pass away.'}
      </Text>
    </SContentContainer>
  )
}
